import { useEffect } from 'react'
import useImageBrowserGroup from './useImageBrowserGroup'
import { getImagesFromApidList } from '../../../../shared/utils/getImagesFromApidList'
import { useSharedBrowserDispatchContext } from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'
import getApidsFromOralGen from '../../../../shared/utils/getApidsFromOralGen'

export default function useWatchApidsForThumbnails() {
  const { imageApids, types } = useImageBrowserGroup()
  const sharedBrowserDispatch = useSharedBrowserDispatchContext()
  const createApids = types?.includes('ORAL_GEN') ? getApidsFromOralGen : getImagesFromApidList

  useEffect(() => {
    if (imageApids && imageApids.length) {
      sharedBrowserDispatch({
        type: 'SET_THUMBNAILS',
        value: createApids(imageApids),
      })
    }
  }, [imageApids, sharedBrowserDispatch, createApids])
}
